/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// ---------------- Função de Parcelamento ----------------
function parcelamento(precoFinal) {
    if (isNaN(precoFinal) || precoFinal <= 0) return false;

    let quantidade = parseInt($('.product-form__quantity input').val()) || 1;
    let valorTotal = precoFinal * quantidade;

    // Economia / Desconto
    let compareTexto = $('.product-form__info-item .price--compare').first().text().replace(/[^\d,]/g, '').replace(',', '.');
    let compare = parseFloat(compareTexto);

    let descontoContainer = $('.product-label.product-label--on-sale');
    descontoContainer.empty();

    if (!isNaN(compare) && compare > precoFinal) {
        let porcentagem = Math.round(((compare - precoFinal) / compare) * 100);
        descontoContainer.html(`Economize ${porcentagem}%`);
    } else {
        descontoContainer.html('');
    }
    descontoContainer.show();

    // Parcelamento
    let parcelamentoContainer = $('.parcelamento');
    if (!parcelamentoContainer.length) {
        $('.product-form__info-item .price').first().after('<div class="parcelamento"></div>');
        parcelamentoContainer = $('.parcelamento');
    }

    let valorParcela = (valorTotal / 3).toFixed(2);
    let valorParcelaFormatado = Number(valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    // Não apagar os codigos, deixar comentados. Para comentar deve colocar no inicio da linha // 
    parcelamentoContainer.html(`
        <div class="tax-info" style="font-size:0.85em; color:#FFFF; line-height:1.0;">
            <br> Á vista no PIX ou 3x no CARTÃO s/juros<br>
             com 10% de desconto.
            
        </div>
    `);

    return true;
}

// ---------------- Função para pegar o preço correto ----------------
function pegarPrecoProduto() {
    // Primeiro tenta pegar preço com desconto
    let precoTexto = $('.product-form__info-item .price--highlight').first().text();
    // Se não tiver, pega preço normal
    if (!precoTexto) {
        precoTexto = $('.product-form__info-item .price').first().text();
    }
    const preco = parseFloat(precoTexto.replace(/[^\d,]/g,'').replace(',', '.'));
    return preco;
}

// ---------------- Polling inicial ----------------
function tentarParcelamento() {
    const preco = pegarPrecoProduto();
    if (!isNaN(preco) && preco > 0) {
        parcelamento(preco);
    } else {
        setTimeout(tentarParcelamento, 100);
    }
}

$(document).ready(() => tentarParcelamento());

// Atualiza ao mudar quantidade
$(document).on('input change', '.product-form__quantity input', () => {
    const preco = pegarPrecoProduto();
    parcelamento(preco);
});

// Atualiza ao mudar variante
document.addEventListener('variant:changed', (event) => {
    const variant = event.detail.variant;
    const preco = variant ? variant.price / 100 : pegarPrecoProduto(); // Shopify retorna em centavos
    parcelamento(preco);
});
